import React, { useState } from "react";
import {
  Box,
  Checkbox,
  FormControl,
  FormLabel,
  Stack,
  Textarea,
  Text,
  InputGroup,
  Divider,
  NumberInput,
  NumberInputField,
  Input,
} from "@chakra-ui/core";
import { MdEuroSymbol } from "react-icons/md";

/** Conllecting/Rendering info about the customer order (Reference/Description ...) */

const OrderDetailsForm = ({ customerInfo, successMessage, setFormData }) => {
  const [checkboxValue, setCheckboxValue] = useState(true);

  const handleChange = ({ target: { name, value } }) => {
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleCheckboxChange = ({ target: { name, value } }) => {
    const newCheckboxValue = !checkboxValue;
    setCheckboxValue(newCheckboxValue);
    setFormData((prevState) => ({
      ...prevState,
      [name]: newCheckboxValue,
    }));
  };

  const setFocusStyle = (id) => {
    const element = document.getElementById(id);
    element.classList.add("focus");
  };

  const removeFocusStyle = (id) => {
    const element = document.getElementById(id);
    element.classList.remove("focus");
  };

  /** If we already reached the end of the 
  cycle within the happy path we do not render the form anymore */
  if (successMessage) {
    return <></>;
  }

  return (
    <>
      {/* <Stack mb="20px" alignItems="center" justifyContent="flex-start" isInline>
        <Box color="success.400" as={MdKeyboardArrowRight} fontSize="48px" />
        <Text color="primary.400" fontSize="lg">
          {customerInfo.firstName} {customerInfo.lastName} {customerInfo.phone}
        </Text>
      </Stack> */}
        <Stack spacing={4}>
          <Stack spacing={2} borderRadius="10px">
            <FormLabel>Reference</FormLabel>
            <Input focusBorderColor="success.500" type="text" name="customerRef" placeholder="Order Reference" onChange={handleChange}/>
            <FormControl isRequired>
            <FormLabel>Order details</FormLabel>
            <Textarea
              isRequired={true}
              focusBorderColor="success.500"
              name="description"
              onChange={handleChange}
              placeholder="Order description/reference"
            />
            <FormLabel>Amount to be paid</FormLabel>
            <InputGroup>
              <NumberInput>
                <Stack
                  borderRadius="5px"
                  px={1}
                  isInline
                  borderWidth="2px"
                  alignItems="center"
                  id="amount-field-wrapper"
                >
                  <Box fontSize="28px" as={MdEuroSymbol} color="primary.400" />
                  <NumberInputField
                    name="amount"
                    onChange={handleChange}
                    onBlur={() => removeFocusStyle("amount-field-wrapper")}
                    onFocus={() => setFocusStyle("amount-field-wrapper")}
                    placeholder="Enter amount"
                    pl={0}
                    border="none"
                    _focus={{ border: "none" }}
                  />
                </Stack>
              </NumberInput>
            </InputGroup>
            </FormControl>
            <Box bg="warning.100" my="16px" p="12px">
              <Checkbox
                borderColor="primary.400"
                size="lg"
                variantColor="warning"
                onChange={handleCheckboxChange}
                value={checkboxValue}
                name="sms"
                defaultIsChecked
              >
                Send as SMS
                <Text fontSize="xs">
                  Automatically send the payment request link as SMS to
                  <Box as="span" fontWeight="bold">
                    {" "}
                    {customerInfo.phone}
                  </Box>
                </Text>
              </Checkbox>
            </Box>
          </Stack>
        </Stack>
      <Divider my={6} />
    </>
  );
};

export default OrderDetailsForm;
